'use client'

import { FC, useContext, useMemo, useRef, useEffect } from 'react'
import { ChatbotUIChatContext } from '@/context/chat'

import { getTimeBasedGreeting } from '@/lib/greetings'
import { GreetingLosiMark } from '@/components/losi-bot/greeting-losi-mark'
import { useTranslation } from 'react-i18next'

interface BrandProps {
  theme?: 'dark' | 'light'
  userName?: string
  loading?: boolean
  /** Kept for call-site compatibility; the mark always plays. */
  loadAnimation?: boolean
}

export const Brand: FC<BrandProps> = ({ userName }) => {
  const { isNewChat } = useContext(ChatbotUIChatContext)
  const { t } = useTranslation()

  // Store the stable greeting in a ref to prevent it from changing during the chat
  const stableGreetingRef = useRef<string | null>(null)
  const lastIsNewChatRef = useRef<boolean>(false)

  // Generate greeting only when truly starting a new chat or on initial mount
  useEffect(() => {
    // Only generate a new greeting if:
    // 1. We don't have a stable greeting yet (initial mount)
    // 2. isNewChat changed from false to true (starting a new chat)
    if (!stableGreetingRef.current || (isNewChat && !lastIsNewChatRef.current)) {
      stableGreetingRef.current = getTimeBasedGreeting(isNewChat, t)
    }
    lastIsNewChatRef.current = isNewChat
  }, [isNewChat, t])

  // Use the stable greeting
  const greeting = stableGreetingRef.current || getTimeBasedGreeting(false, t)

  const firstName = useMemo(() => {
    return userName?.split(' ')[0] || ''
  }, [userName])

  const formattedGreeting = useMemo(() => {
    return userName || userName?.trim() !== ''
      ? greeting.replace('!', `,`) + ` ${firstName}`
      : greeting.replace('!', ``)
  }, [greeting, userName, firstName])

  return (
    <div className="flex flex-row items-center space-x-1 p-1">
      <div className="">
        <GreetingLosiMark size={45} className="rounded-sm" />
      </div>

      {/* <h1 className="text-4xl font-bold tracking-wide">Losi Chat</h1> */}
      <div className="flex flex-col items-center">
        {/* <h4 className="text-center text-sm">
          Interact with 40+ leading AI models in one place.
        </h4> */}
        <h2 className="animate-fade-in text-center text-2xl">{formattedGreeting}</h2>

        {/* <h3
          className={cn(
            "pt-2 text-center text-3xl",
            "animate-fade-in delay-1000"
          )}
        >
          {t("How can I help you today?")}
        </h3> */}

        {/* <h4 className="text-center text-sm">
          Featuring Losi Max, Losi Mini, and so
          much more.
        </h4> */}
      </div>
    </div>
  )
}
